export default "__VITE_ASSET__39885de5__"